import thdCustomer from '@thd-olt-global/thd-customer';
import { PATH } from '../constants/routes';

export const getAuthorizationToken = () =>
  window.encodeURIComponent(thdCustomer.token);

export const getIsUserLoggedIn = () => thdCustomer.isLoggedIn;

export const getIsUserPersisted = () => thdCustomer.isPersisted;

export const getUserEmail = () => thdCustomer.email;

export const getOnlineOrderPath = () =>
  thdCustomer.isLoggedIn ? PATH.ORDER_HISTORY : PATH.ONLINE_ORDER;

export const getRedirectToTrackingPath = () =>
  thdCustomer.isLoggedIn ? PATH.ORDER_HISTORY : PATH.ORDER_TRACKING;

export const getHostName = () =>
  process.env.NODE_ENV === 'development'
    ? 'homedepot.com'
    : window.location.hostname;

export const getMemberIdRatingsReviews = () => {
  const { svocID } = thdCustomer;
  return thdCustomer.token && svocID ? svocID : thdCustomer.userID;
};

export const getTmxId = () =>
  window.THD_ACCOUNT_LIB &&
  window.THD_ACCOUNT_LIB.TMX &&
  window.THD_ACCOUNT_LIB.TMX.getTMXsessionId();
